import CityPageTemplate from "../city-template/CityPageTemplate";
import { columbiaConfig } from "./data";

export default function ColumbiaPage() {
  return <CityPageTemplate config={columbiaConfig} />;
}